import {AxiosInstance} from 'axios';
import {
  CheckWindowPeriod,
  ConfigurationExamRequest,
  ConfigurationExamResponse,
  ConfigurationType,
  OpenPeriodConfigRequest,
  OpenPeriodConfigResponse,
} from './model';
import {ROUTE} from './route';
import {axiosFactory} from '../../client';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const timeout = 5000;

export const configClient = axiosFactory(baseURL, timeout);

export const configTestClient = (configClient as unknown) as AxiosInstance;

export const getFeatureConfiguration = () =>
    configClient.get<ConfigurationType[]>(ROUTE.GET_CONFIGURATION_TYPE);

export const postConfigurationExam = (csrfToken: string, data: ConfigurationExamRequest) =>
    configClient.post<ConfigurationExamResponse>(csrfToken, ROUTE.POST_CONFIGURATION_TYPE, data);

export const postOpenPeriodConfig = (csrfToken: string, data: OpenPeriodConfigRequest) =>
    configClient.post<OpenPeriodConfigResponse>(csrfToken, ROUTE.POST_OPEN_PERIOD_CONFIG, data);

export const putOpenPeriodConfig = (csrfToken: string, data: OpenPeriodConfigResponse) =>
    configClient.put<undefined>(csrfToken, ROUTE.PUT_OPEN_PERIOD_CONFIG, data);

export const postCheckWindowPeriod = (csrfToken: string, data: CheckWindowPeriod) =>
    configClient.post<undefined>(csrfToken, ROUTE.POST_WINDOW_PERIOD, data);
